import React from 'react';
import QuestionsComponent from '../components/questions/QuestionsComponent';

const Questions = () =>{
    return(
        <QuestionsComponent />
    );
}

export default Questions;